import updatePreference from '@/repositories/Forms/updatePreference'

const updatePreferenceService = {
  async get(data: any) {
    return (await updatePreference.updatePreference()).post('/moengage-subscription', data)
  }
}

export default updatePreferenceService
